import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {}

const PerformanceIcon: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "22"}
      height={height ?? "24"}
      viewBox="0 0 22 24"
      fill="none"
      style={{ color: finalColor }}
    >
      <path
        d="M10.7027 1.5009C10.8459 1.5009 10.9866 1.53842 11.1104 1.61034L19.4967 6.45199C19.7481 6.59708 19.9044 6.86786 19.9044 7.15866V16.842C19.9044 17.1328 19.7481 17.4035 19.4967 17.5486L11.1104 22.3903C10.9866 22.4616 10.8452 22.4997 10.7027 22.4997C10.5601 22.4997 10.4187 22.4622 10.2949 22.3903L1.90864 17.548C1.65724 17.4029 1.5009 17.1321 1.5009 16.8413V7.15866C1.5009 6.86786 1.65724 6.59708 1.90864 6.45199L10.2949 1.61034C10.4187 1.53905 10.5601 1.5009 10.7027 1.5009ZM10.7027 0C10.3024 0 9.90281 0.103187 9.54447 0.310186L1.15819 5.15184C0.441514 5.56583 0 6.33067 0 7.15866V16.842C0 17.67 0.441514 18.4348 1.15819 18.8482L9.54447 23.6898C9.90281 23.8968 10.303 24 10.7027 24C11.1023 24 11.5025 23.8968 11.8609 23.6898L20.2471 18.8482C20.9638 18.4342 21.4053 17.6693 21.4053 16.842V7.15866C21.4053 6.33067 20.9638 5.56646 20.2471 5.15246L11.8609 0.310186C11.5025 0.103187 11.1023 0 10.7027 0Z"
        fill="#66788F"
      />
      <path d="M7.70608 11.5703H5.70801V17.0967H7.70608V11.5703Z" fill="currentColor" />
      <path d="M11.7022 8.4248H9.7041V17.0975H11.7022V8.4248Z" fill="currentColor" />
      <path d="M15.6983 6.63965H13.7002V17.0978H15.6983V6.63965Z" fill="currentColor" />
    </svg>
  );
};

export default PerformanceIcon;
